import { OrderDoctypes } from './orderDoctypeConstants';
/** 
  Warning: The constants in this file are not fully replicated throughout
  the project. Before making any changes, please ensure that the values 
  are consistently updated in all relevant locations to avoid discrepancies
  and potential errors.
*/
import newOrderIcon from '@/assets/img/icons_orders/NP.svg';
import firstTimePurchaseIcon from '@/assets/img/icons_orders/PNC.svg';
import promotionalIcon from '@/assets/img/icons_orders/POP.svg';
import unknownIcon from '@/assets/img/icons_orders/unknown.svg';

export const OrderDoctypeMetaData = {
  PRIVATE_CHANNEL: {
    key: OrderDoctypes.PRIVATE_CHANNEL,
    label: 'Nuevo pedido',
    productLabel: '',
    longLabel: 'NUEVO PEDIDO',
    icon: newOrderIcon,
  },
  RETAIL_CHANNEL: {
    key: OrderDoctypes.RETAIL_CHANNEL,
    label: 'Nuevo pedido',
    productLabel: '',
    longLabel: 'NUEVO PEDIDO',
    icon: newOrderIcon,
  },
  FIRST_TIME_PURCHASE: {
    key: OrderDoctypes.FIRST_TIME_PURCHASE,
    label: 'Pedido de productos nuevos',
    productLabel: 'Producto nuevo',
    longLabel: 'PEDIDO DE PRODUCTOS NUEVOS (PNC)',
    icon: firstTimePurchaseIcon,
  },
  PROMOTIONAL: {
    key: OrderDoctypes.PROMOTIONAL,
    label: 'Pedido POP',
    productLabel: 'Bono POP',
    longLabel: 'PEDIDO BONO POP',
    icon: promotionalIcon,
  },
};

export const UNKNOWN_ORDER_TYPE = {
  key: 'unknown',
  label: 'Desconocido',
  longLabel: 'Tipo de pedido desconocido',
  productLabel: 'Producto desconocido',
  icon: unknownIcon,
};

// Build a lookup table from order code (like 'PSNW') to full metadata object.
// This allows fast access using the order type code directly, e.g., OrderDoctypeMetaDataByDoctype['PSNW']
export const OrderDoctypeMetaDataByDoctype = Object.values(
  OrderDoctypeMetaData
).reduce((acc, meta) => {
  acc[meta.key] = meta;
  return acc;
}, {});

export function getOrderTypeMetaByDoctype(doctype) {
  return OrderDoctypeMetaDataByDoctype[doctype] || UNKNOWN_ORDER_TYPE;
}
